import { render, staticRenderFns } from "./MdtModal.vue?vue&type=template&id=cf615318&scoped=true"
import script from "./MdtModal.vue?vue&type=script&lang=js"
export * from "./MdtModal.vue?vue&type=script&lang=js"
import style0 from "./MdtModal.vue?vue&type=style&index=0&id=cf615318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf615318",
  null
  
)

export default component.exports